import React from 'react';
import ChatBubble from 'eCoach/ChatBubble';
import { LoadingStatus } from 'eCoach/hooks/useEcoachItemsConsumer';
import * as Text from 'theme/components/Text.style';

interface ECoachResponseProps {
  status?: string;
  loadingTitle?: string;
  loader?: React.ReactNode;
  children: React.ReactNode;
}

export default function ECoachResponse({
  status,
  loadingTitle,
  loader,
  children,
}: ECoachResponseProps): JSX.Element {
  return (
    <ChatBubble>
      {status === LoadingStatus.LOADED ? (
        children
      ) : (
        <>
          {loadingTitle && <Text.H5>{loadingTitle}</Text.H5>}
          {loader && loader}
        </>
      )}
    </ChatBubble>
  );
}
